import { ArrowRight, AlertTriangle, Wand2 } from "lucide-react";

const MappingRow = ({ m, i }) => (
  <div data-testid={`category-mapping-${i}`} className="flex flex-wrap items-center gap-1.5 px-3 py-1.5 text-xs border-b border-slate-100 last:border-0">
    <span className="font-semibold text-slate-700">{m.original}</span>
    <ArrowRight size={12} className="text-slate-400" />
    <span className="font-semibold text-slate-900">{m.mapped}</span>
    <span className={m.status === "auto" ? "text-emerald-600" : "text-amber-600 font-semibold"}>
      ({m.status === "auto" ? "auto-mapped" : "please review"})
    </span>
    <span className="ml-auto font-mono text-slate-400">{m.count} row{m.count === 1 ? "" : "s"}</span>
  </div>
);

export const CategoryMappingReport = ({ report }) => {
  const maps = report.category_mappings || [];
  const auto = maps.filter((m) => m.status === "auto");
  const flagged = report.flagged || [];
  if (maps.length === 0) return null;
  return (
    <div className="mt-3 space-y-3">
      {auto.length > 0 && (
        <div data-testid="auto-mapped-section">
          <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-emerald-700 mb-1.5"><Wand2 size={13} /> Auto-mapped categories</p>
          <div className="max-h-40 overflow-y-auto rounded-lg border border-emerald-100 bg-white">
            {auto.map((m, i) => <MappingRow key={`a${i}`} m={m} i={`auto-${i}`} />)}
          </div>
        </div>
      )}
      {flagged.length > 0 && (
        <div data-testid="review-section">
          <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-amber-700 mb-1.5"><AlertTriangle size={13} /> Category unclear, please review</p>
          <div className="max-h-48 overflow-y-auto rounded-lg border border-amber-200 bg-amber-50/40">
            {flagged.map((f, i) => (
              <div key={i} data-testid={`review-row-${i}`} className="flex flex-wrap items-center gap-1.5 px-3 py-1.5 text-xs border-b border-amber-100 last:border-0">
                <span className="font-mono text-slate-400">Row {f.row}</span>
                <span className="font-semibold text-slate-700 truncate max-w-[10rem]">{f.name}</span>
                <span className="text-slate-500">{f.original}</span>
                <ArrowRight size={12} className="text-slate-400" />
                <span className="font-semibold text-slate-900">{f.mapped}</span>
                <span className="ml-auto text-amber-700">{f.reason}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      <details data-testid="full-mapping-details" className="rounded-lg border border-slate-200 bg-white">
        <summary className="cursor-pointer px-3 py-2 text-xs font-bold uppercase tracking-wide text-slate-500">Full category mapping used ({maps.length})</summary>
        {maps.map((m, i) => <MappingRow key={`f${i}`} m={m} i={`full-${i}`} />)}
      </details>
    </div>
  );
};
